import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { NO_VALUE } from '../dash/dash.pipe';
import { Salutation } from '@vi-iot/client/index';

@Pipe({
  name: 'salutation',
  standalone: true,
})
export class SalutationPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(salutation: Salutation): string {
    switch (salutation) {
      case Salutation.Mr:
        return this.translateService.instant('SALUTATION.MR');
      case Salutation.Mrs:
        return this.translateService.instant('SALUTATION.MRS');
      default:
        return NO_VALUE;
    }
  }
}
